import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "regenerator-runtime/runtime.js";
import { useWebSocket } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { useLinkShare } from '~/core/composables/useLinkShare';
import { APP_LINKS, CONTAINER_WIDTH, DIALOG_MESSAGE as CORE_DIALOG } from '~/core/constants';
import { ymGoal } from '~/core/utils/yandexReachGoal';
import QrReaderPopup from '~/core/components/QrReaderPopup/QrReaderPopup.vue';
import { CameraErrors } from '~/core/enums/errors';
import { useAppLink, usePending } from '~/core/composables';
import { uuidv4 } from '~/core/utils/uuidv4';
import { DEFAULT_HEARTBEAT_MESSAGE } from '~/core/constants/socket';
import { createMtlinkSession } from '~/core/functions';
import { SocketStatus } from '~/core/enums/socketStatus';
import BottomControlsButtons from '~/core/components/BottomControlsButtons/BottomControlsButtons.vue';
import ResultsPlaceholder from '~/core/components/ResultsPlaceholer/ResultsPlaceholder.vue';
import MedcardShareSelectItems from '~/core/components/MedcardShare/MedcardShareSelectItems.vue';
import useMainDialogStore from '~/stores/useMainDialogStore';
import useMedcardStore from '~/stores/useMedcardStore';
import useMedcardDocumentsStore from '~/stores/useMedcardDocumentsStore';
import useProfileStore from '~/stores/useProfileStore';
import { getShareLink } from '~/features/Medcard/functions';
import { MedcardStatus } from '~/features/Profile/enums';
export default defineComponent({
  name: 'MedcardShare',
  components: {
    MedcardShareSelectItems: MedcardShareSelectItems,
    ResultsPlaceholder: ResultsPlaceholder,
    BottomControlsButtons: BottomControlsButtons,
    QrReaderPopup: QrReaderPopup
  },
  emits: ['scanned'],
  setup: function setup(_, _ref) {
    var emit = _ref.emit,
      expose = _ref.expose;
    var profileStore = useProfileStore();
    var _storeToRefs = storeToRefs(profileStore),
      medcardActiveSessionsCount = _storeToRefs.medcardActiveSessionsCount;
    var medcardStore = useMedcardStore();
    var _storeToRefs2 = storeToRefs(medcardStore),
      isMedcardTokenValid = _storeToRefs2.isMedcardTokenValid;
    var medcardDocumentsStore = useMedcardDocumentsStore();
    var qrReaderPopup = ref(null);
    var medcardShareSelectItems = ref(null);
    var steps = ['Попросите врача открыть сайт mt.link', 'Отсканируйте QR-код c монитора врача', 'Готово, медкарта сразу откроется'];
    var isSuccessPopupActive = ref(false);
    var retryPopup = ref({
      isActive: false,
      resumeCallback: null
    });
    var medcardShareStep = ref(1);
    var _useNuxtApp = useNuxtApp(),
      $captureException = _useNuxtApp.$captureException,
      $featureFlag = _useNuxtApp.$featureFlag;
    var $dialog = useMainDialogStore();
    var _useLinkShare = useLinkShare(),
      handleShare = _useLinkShare.handleShare;
    var _useAppLink = useAppLink(),
      storeLink = _useAppLink.storeLink;
    var $router = useRouter();
    var _usePending = usePending(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!(medcardStore.status === MedcardStatus.Expired || !isMedcardTokenValid.value)) {
                _context.next = 4;
                break;
              }
              $router.push({
                name: 'medcard'
              });
              return _context.abrupt("return");
            case 4:
              _context.next = 6;
              return medcardDocumentsStore.fetchMedcardDocumentsCount();
            case 6:
              _context.next = 8;
              return medcardDocumentsStore.fetchMedcardFolders();
            case 8:
              _context.next = 10;
              return medcardStore.fetchHealthDiariesStatusForFamilyProfile();
            case 10:
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              $captureException(_context.t0, {
                component: 'MedcardShare',
                method: 'usePending'
              });
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 12]]);
      }))),
      isLoading = _usePending.pending,
      refresh = _usePending.refresh;
    var isNextStepButtonDisabled = computed(function () {
      var _medcardShareSelectIt;
      return !((_medcardShareSelectIt = medcardShareSelectItems.value) !== null && _medcardShareSelectIt !== void 0 && _medcardShareSelectIt.selected);
    });
    watch(function () {
      return retryPopup.value.isActive;
    }, function (val) {
      if (!val) {
        retryPopup.value.resumeCallback = null;
      }
    });
    function handleLinkShare() {
      return _handleLinkShare.apply(this, arguments);
    }
    function _handleLinkShare() {
      _handleLinkShare = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var payload, _yield$getShareLink, link, code, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (medcardShareSelectItems.value) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              _context3.prev = 2;
              payload = medcardShareSelectItems.value.selectedItems;
              _context3.next = 6;
              return getShareLink(payload);
            case 6:
              _yield$getShareLink = _context3.sent;
              link = _yield$getShareLink.link;
              code = _yield$getShareLink.code;
              message = "\u0421\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u043C\u0435\u0434\u043A\u0430\u0440\u0442\u0443 ".concat(link, "\n\u041A\u043E\u0434 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 ").concat(code, " \u2014 \u043E\u043D \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0434\u0438\u043D \u0440\u0430\u0437. \u0415\u0441\u043B\u0438 \u043D\u0443\u0436\u0435\u043D \u0431\u0443\u0434\u0435\u0442 \u043D\u043E\u0432\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F, \u043F\u0440\u0438\u0448\u043B\u044E \u0441\u0441\u044B\u043B\u043A\u0443 \u0441\u043D\u043E\u0432\u0430.");
              ymGoal('clickSendMedcard');
              handleShare(message);
              _context3.next = 18;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](2);
              $dialog.open(_objectSpread({}, CORE_DIALOG.BASE_ERROR));
              $captureException(_context3.t0, {
                component: 'MedcardShare',
                method: 'handleLinkShare'
              });
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 14]]);
      }));
      return _handleLinkShare.apply(this, arguments);
    }
    function handleOpenQr() {
      var _qrReaderPopup$value;
      (_qrReaderPopup$value = qrReaderPopup.value) === null || _qrReaderPopup$value === void 0 ? void 0 : _qrReaderPopup$value.show();
    }
    function handleCameraError(_x) {
      return _handleCameraError.apply(this, arguments);
    }
    function _handleCameraError() {
      _handleCameraError = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
        var isResolved;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(e === CameraErrors.NotAllowed)) {
                _context4.next = 4;
                break;
              }
              _context4.next = 3;
              return $dialog.open(CORE_DIALOG.CAMERA_ACCESS);
            case 3:
              return _context4.abrupt("return");
            case 4:
              _context4.next = 6;
              return $dialog.open(CORE_DIALOG.CAMERA_CONNECTION_ERROR);
            case 6:
              isResolved = _context4.sent;
              if (!isResolved) {
                _context4.next = 12;
                break;
              }
              if (!$featureFlag('wff_fix_app_redirects')) {
                _context4.next = 11;
                break;
              }
              window.open(APP_LINKS.smartAppLink, '_blank');
              return _context4.abrupt("return");
            case 11:
              window.open(storeLink.value, '_blank');
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _handleCameraError.apply(this, arguments);
    }
    function handleQrScanned(_ref3) {
      var decodedText = _ref3.decodedText,
        pause = _ref3.pause,
        resume = _ref3.resume,
        loading = _ref3.loading;
      var isSocketInitialized = false;
      var errorCallback = function errorCallback() {
        loading(false);
        retryPopup.value.isActive = true;
        retryPopup.value.resumeCallback = resume;
        if (isSocketInitialized) {
          wsClose();
          isSocketInitialized = false;
        }
      };
      pause(true);
      loading(true);
      var url = new URL(decodedText);
      var composedQrTokens = new URLSearchParams(url.search).get('qr_tokens');
      if (!composedQrTokens) {
        errorCallback();
        return;
      }
      var _composedQrTokens$spl = composedQrTokens.split('XXX'),
        _composedQrTokens$spl2 = _slicedToArray(_composedQrTokens$spl, 2),
        masterToken = _composedQrTokens$spl2[0],
        infoToken = _composedQrTokens$spl2[1];
      var uuid = uuidv4();
      var _useWebSocket = useWebSocket("wss://".concat(location.host, "/ws/mt_link/confirmation/").concat(uuid, "?subscribe-user"), {
          autoReconnect: true,
          heartbeat: {
            message: DEFAULT_HEARTBEAT_MESSAGE
          },
          onConnected: function () {
            var _onConnected = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
              var payload;
              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (medcardShareSelectItems.value) {
                      _context2.next = 2;
                      break;
                    }
                    return _context2.abrupt("return");
                  case 2:
                    _context2.prev = 2;
                    payload = _objectSpread({
                      uuid: uuid,
                      masterAnonymousToken: masterToken,
                      infoAnonymousToken: infoToken
                    }, medcardShareSelectItems.value.selectedItems);
                    _context2.next = 6;
                    return createMtlinkSession(payload);
                  case 6:
                    _context2.next = 12;
                    break;
                  case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2["catch"](2);
                    $captureException(_context2.t0, {
                      component: 'MedcardShare',
                      method: 'handleQrScanned'
                    });
                    errorCallback();
                  case 12:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2, null, [[2, 8]]);
            }));
            function onConnected() {
              return _onConnected.apply(this, arguments);
            }
            return onConnected;
          }()
        }),
        wsMessage = _useWebSocket.data,
        status = _useWebSocket.status,
        wsClose = _useWebSocket.close;
      isSocketInitialized = true;
      watch(wsMessage, function () {
        var _qrReaderPopup$value2;
        (_qrReaderPopup$value2 = qrReaderPopup.value) === null || _qrReaderPopup$value2 === void 0 ? void 0 : _qrReaderPopup$value2.hide();
        ymGoal('clickMtLink');
        medcardActiveSessionsCount.value++;
        emit('scanned');
        isSuccessPopupActive.value = true;
        isSocketInitialized = false;
        wsClose();
      });
      setTimeout(function () {
        if (status.value !== SocketStatus.Closed) {
          errorCallback();
        }
      }, 5000);
    }
    function handleSubmitRetryPopup() {
      var _retryPopup$value$res, _retryPopup$value;
      retryPopup.value.isActive = false;
      (_retryPopup$value$res = (_retryPopup$value = retryPopup.value).resumeCallback) === null || _retryPopup$value$res === void 0 ? void 0 : _retryPopup$value$res.call(_retryPopup$value);
    }
    function handleCloseRetryPopup() {
      var _qrReaderPopup$value3;
      retryPopup.value.isActive = false;
      (_qrReaderPopup$value3 = qrReaderPopup.value) === null || _qrReaderPopup$value3 === void 0 ? void 0 : _qrReaderPopup$value3.hide();
    }
    function resetState() {
      var _medcardShareSelectIt2;
      medcardShareStep.value = 1;
      (_medcardShareSelectIt2 = medcardShareSelectItems.value) === null || _medcardShareSelectIt2 === void 0 ? void 0 : _medcardShareSelectIt2.resetState();
      refresh();
    }
    expose({
      resetState: resetState
    });
    return {
      CONTAINER_WIDTH: CONTAINER_WIDTH,
      qrReaderPopup: qrReaderPopup,
      medcardShareSelectItems: medcardShareSelectItems,
      steps: steps,
      retryPopup: retryPopup,
      isSuccessPopupActive: isSuccessPopupActive,
      medcardShareStep: medcardShareStep,
      isNextStepButtonDisabled: isNextStepButtonDisabled,
      isLoading: isLoading,
      handleLinkShare: handleLinkShare,
      handleOpenQr: handleOpenQr,
      handleCameraError: handleCameraError,
      handleQrScanned: handleQrScanned,
      handleSubmitRetryPopup: handleSubmitRetryPopup,
      handleCloseRetryPopup: handleCloseRetryPopup
    };
  }
});